import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  modalForm: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2.5) || '20px',
    paddingTop: theme.spacing(1) || '8px',
  },
}))

export default useStyles
